/*
 * @Author: Qzx
 * @Date: 2020-04-01 11:44:55
 * @Description: 项目相关配置信息
 * @LastEditors: wangxin35
 * @LastEditTime: 2020-08-24 12:23:30
 */
export default {
  eventid: 'teacherDayActivities', // 项目唯一标识
  sourceId: '',
  sGroupId: '140079', // 活动唯一标识
  projectName: '五月献礼人民教师', // 活动名称
  description: '五月献礼人民教师', // 项目相关描述
  developer: 'wangxin35 v_zhouzhaojun v_zhoufengtao', // 参与项目开发者
  xesShare: {
    title: '五月献礼人民教师', // 标题
    desc: '新华网五一起送全国教师子女，由学而思网校提供的暑假系统课', // 描述
    link: 'https://t.xueersi.com/gR9thMU6', // 链接
    imgUrl: 'https://editor.xesimg.com/tailor/resource/%E7%BB%8455-1619440728820.png' // 图标
  }, // 活动分享相关
  xesLog: {
    pages: {
      home: {
        uid: '1',
        name: '活动首页',
        level: '1'
      }
    }
  } // 日志打点相关(展现)
}
